import { h, resolveComponent } from 'vue';
import ExchangeLandingView from '../views/ExchangeLandingView/index.vue';
import ExchangeDetailsView from '../views/ExchangeDetailsView/index.vue';
import ExchangeConfirmationView from '../views/ExchangeConfirmationView/index.vue';

export default [{
  path: '/:locale/exchange',
  component: {
    render() { return h(resolveComponent('router-view')); },
  },
  children: [{
    path: '',
    name: 'exchangeLandingView',
    component: ExchangeLandingView,
  }, {
    path: 'details',
    component: {
      render() { return h(resolveComponent('router-view')); },
    },
    children: [{
      path: '',
      name: 'exchangeDetailsView',
      component: ExchangeDetailsView,
    }, {
      path: 'confirmation',
      name: 'exchangeConfirmationView',
      component: ExchangeConfirmationView,
    }],
  }],
}];
